import { upload, get } from "functions/BaseAxios";
import { type } from "os";
import numbro from 'numbro';
import imageCompression from 'browser-image-compression';

export const ID_IMAGE_SELFIE = 'ID_IMAGE_SELFIE';
export const ID_IMAGE = 'ID_IMAGE';
export const ALERT_MODAL = 'ALERT_MODAL';
export const UNDER_CONSTRUCTION_MODAL = 'UNDER_CONSTRUCTION_MODAL';
export const UPLOAD_IMG = 'UPLOAD_IMG';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';

export const uploadIDImg = (file: any) => {
    return async (dispatch: DispatchGeneral) => {
        var data = await upload({
            file,
            dir: 'xlimit/'
        });
        dispatch({
            type: ID_IMAGE,
            payload: data.code ? null : data.urls[(data.urls).length - 1],
        });
    };
}
export const uploadSelfieIDImg = (file: any) => {
    return async (dispatch: DispatchGeneral) => {
        var data = await upload({
            file,
            dir: 'xlimit/'
        });
        dispatch({
            type: ID_IMAGE_SELFIE,
            payload: data.code ? null : data.urls[(data.urls).length - 1],
        });
    };
}

export const showAlert = (content: any, title: any, show: boolean) => {
    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: ALERT_MODAL,
            payload: {
                content,
                title,
                show
            },
        });
    };
}

export const showUnderConstructionAlert = (show: boolean, content = "This Feature is under construction", title = "WARNING !") => {
    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: UNDER_CONSTRUCTION_MODAL,
            payload: {
                content,
                title,
                show
            },
        });
    };
}

export const uploadIMG = async (file: any) => {
    const options = {
        maxSizeMB: 1.5,
        maxWidthOrHeight: 1920,
        useWebWorker: true
    }
    const compressedFile = await imageCompression(file, options);

    return await upload({
        file: compressedFile
    });
}

export const uploadIDImgUpdate = async (file: any) => {
    return await upload({
        file,
        dir: 'xlimit/'
    });
}
export const uploadSelfieIDImgUpdate = async (file: any) => {
    return await upload({
        file,
        dir: 'xlimit/'
    });
}

export function currency(num: any) {
    const amount = typeof num === 'string' ? parseFloat(num) : num;
    return '$' + numbro(amount).format({ thousandSeparated: true });
}

export const roundNumber = (number: any) => {
    return (Math.round(number * 100) / 100).toFixed(2);
};